<template>
  <fieldset>
    <div class="form-group">
      <label
        class="sr-only"
        for="listing[hero_content_type]"
      >
        Hero Content Type
      </label>
      <select
        id="listing[hero_content_type]"
        name="hero_content_type"
        class="custom-select"
        v-model="listing.hero_content_type"
      >
        <option value="default">First photo from the MLS</option>
        <option value="custom_video">A looping video</option>
        <option value="custom_photo">A custom photo</option>
      </select>
    </div>
    <div
      v-if="listing.hero_content_type === 'custom_video'"
      class="form-group"
    >
      <label
        for="listing[hero_custom_video_url]"
      >
        Custom Video URL
      </label>
      <p class="small text-muted">
        Please use a <b>YouTube</b>, <b>Vimeo</b>, <b>Aryeo</b>, or <b>MP4</b> file for this.
      </p>
      <input
        id="listing[hero_custom_video_url]"
        class="form-control"
        type="text"
        name="hero_custom_video_url"
        v-model="listing.hero_custom_video_url"
        placeholder="e.g., https://www.youtube.com/watch?v=dwf0ncjGmQg"
      >
    </div>
    <div
      v-if="listing.hero_content_type === 'custom_photo'"
      class="form-group"
    >
      <input
        type="hidden"
        name="hero_custom_photo_url"
        v-model="listing.hero_custom_photo_url"
      >
      <label
        for="listing[hero_custom_photo_url]"
      >
        Custom Photo
      </label>
      <div
        v-if="listing.hero_custom_photo_url"
        class="mb-2"
      >
        <img
          :src="listing.hero_custom_photo_url"
          class="img-fluid"
        >
      </div>
      <div>
        <p class="small text-muted">
          Please upload a large photo; we will crop
          and resize it to look great on the website.
        </p>
        <upload
          @uploaded="onImageUploaded"
          variant="white"
          :url="uploadUrl"
        ></upload>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Upload from '@/components/Upload'
import api from '@/api'
import urls from '@/api/urls'

export default {
  components: {
    Upload,
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    uploadUrl () {
      return api.defaults.baseURL + '/' + urls.upload.image()
    }
  },
  data () {
    return {
      listing: this.value
    }
  },
  methods: {
    onImageUploaded(response) {
      this.listing.hero_custom_photo_url = response.urls.public
    }
  }
}
</script>